(() => {
  if (window.youMayAlsoLikeScriptInitialized) return;

  window.youMayAlsoLikeScriptInitialized = true;
  const rootSelector = '[data-you-may-also-like]';

  const cartRoot = () => {
    const match = window.location.pathname.match(/^\/[a-z]{2}(-[a-z]{2})?\//i);
    return match ? match[0] : '/';
  };

  const addToCart = (item) => {
    return fetch(`${cartRoot()}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    }).then((res) => {
      if (!res.ok) throw new Error(`cart/add.js ${res.status}`);
      return res.json();
    });
  };

  const openCartDrawer = () => {
    if (!window.cartDrawerCustom) return;
    if (typeof window.cartDrawerCustom.refresh === 'function') window.cartDrawerCustom.refresh();
    if (typeof window.cartDrawerCustom.open === 'function') window.cartDrawerCustom.open();
  };

  const initializeSlider = (root) => {
    const slider = root.querySelector('[data-recommendations-slider]');
    const dots = [...root.querySelectorAll('[data-recommendations-dot]')];

    if (!slider || slider.dataset.recommendationsSliderInitialized === 'true') return;

    slider.dataset.recommendationsSliderInitialized = 'true';

    const slides = [...slider.querySelectorAll('[data-recommendations-slide]')];
    let frameId;

    if (slides.length < 2 || dots.length === 0) return;

    const getScrollTarget = (index) => {
      const firstSlideOffset = slides[0].offsetLeft;
      const maximumScroll = slider.scrollWidth - slider.clientWidth;

      return Math.min(slides[index].offsetLeft - firstSlideOffset, maximumScroll);
    };

    const getActiveIndex = () => dots.reduce((closestIndex, dot, index) => {
      const currentDistance = Math.abs(slider.scrollLeft - getScrollTarget(index));
      const closestDistance = Math.abs(slider.scrollLeft - getScrollTarget(closestIndex));

      return currentDistance < closestDistance ? index : closestIndex;
    }, 0);

    const updateDots = () => {
      const activeIndex = getActiveIndex();

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    slider.addEventListener('scroll', () => {
      cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(updateDots);
    }, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        slider.scrollTo({ left: getScrollTarget(index), behavior: 'smooth' });
      });
    });

    new ResizeObserver(updateDots).observe(slider);
    updateDots();
  };

  const syncOnetimePrice = (panel) => {
    if (!panel) return;
    const checked = panel.querySelector('input[type="radio"]:checked');
    const priceEl = panel.querySelector('[data-ymal-onetime-price]');
    if (priceEl) priceEl.textContent = checked ? (checked.dataset.onetimeMoney || '') : '';
  };

  const initializeAtc = (root) => {
    const modal = root.querySelector('[data-ymal-atc-modal]');
    if (!modal || modal.dataset.ymalAtcInitialized === 'true') return;
    modal.dataset.ymalAtcInitialized = 'true';

    if (window.__ymalAtcAbort) window.__ymalAtcAbort.abort();
    window.__ymalAtcAbort = new AbortController();
    const { signal } = window.__ymalAtcAbort;

    document.querySelectorAll('body > [data-ymal-atc-modal]').forEach((oldModal) => {
      if (oldModal !== modal) oldModal.remove();
    });
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const titleEl = modal.querySelector('#ymal-atc-modal-title');
    const defaultTitle = titleEl ? titleEl.textContent : '';

    const isOpen = () => modal.classList.contains('is-open');

    const hideAllPanels = () => {
      modal.querySelectorAll('[data-ymal-panel]').forEach((panel) => {
        panel.hidden = true;
      });
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ymal-atc-modal-open');
      hideAllPanels();
    };

    const openModal = (panelKey) => {
      hideAllPanels();
      const panel = modal.querySelector(`[data-ymal-panel="${panelKey}"]`);
      if (panel) {
        panel.hidden = false;
        syncOnetimePrice(panel);
        if (titleEl) titleEl.textContent = panel.dataset.ymalTitle || defaultTitle;
      }
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ymal-atc-modal-open');
      const closeBtn = modal.querySelector('.ymal-atc-modal__close');
      if (closeBtn) closeBtn.focus();
    };

    const openFlavors = () => {
      if (!window.NwNewBundle || typeof window.NwNewBundle.openFlavorsModal !== 'function') {
        console.error('[you-may-also-like] flavors picker unavailable');
        return;
      }
      window.NwNewBundle.openFlavorsModal();
    };

    const openPouches = () => {
      const panel = modal.querySelector('[data-ymal-panel="pouches"]');
      if (!panel || !panel.querySelector('[data-pouches-bundle]')) return;
      openModal('pouches');
      const refresh = () => {
        if (typeof window.LarineInitPouchesBundles === 'function') {
          window.LarineInitPouchesBundles();
        }
        panel.querySelectorAll('[data-pouches-bundle]').forEach((bundle) => {
          bundle.dispatchEvent(new CustomEvent('larine:pouches-refresh'));
        });
      };
      requestAnimationFrame(() => requestAnimationFrame(refresh));
    };

    modal.querySelectorAll('[data-ymal-atc-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) closeModal();
    }, { signal });

    document.addEventListener('cart:refresh', () => {
      if (isOpen()) closeModal();
    }, { signal });

    modal.querySelectorAll('[data-ymal-panel]').forEach((panel) => {
      panel.addEventListener('change', (event) => {
        if (event.target && event.target.matches('input[type="radio"]')) {
          syncOnetimePrice(panel);
        }
      });

      panel.addEventListener('click', (event) => {
        const button = event.target.closest('[data-ymal-add]');
        if (!button) return;
        const radio = panel.querySelector('input[type="radio"]:checked');
        if (!radio) return;

        const variantId = Number(radio.dataset.variantId);
        if (!variantId) return;

        const item = { id: variantId, quantity: 1 };
        const sellingPlanId = parseInt(radio.dataset.sellingPlanId, 10);
        if (button.dataset.ymalAdd === 'subscription' && sellingPlanId > 0) {
          item.selling_plan = sellingPlanId;
        }

        button.disabled = true;
        addToCart(item)
          .then(() => {
            closeModal();
            openCartDrawer();
          })
          .catch((error) => {
            console.error('[you-may-also-like]', error);
          })
          .finally(() => {
            button.disabled = false;
          });
      });
    });

    root.querySelectorAll('[data-ymal-atc]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const kind = button.dataset.ymalKind;
        if (kind === 'gum') {
          openFlavors();
          return;
        }
        if (kind === 'pouches') {
          openPouches();
          return;
        }
        if (kind === 'mints' || kind === 'toothpaste') {
          openModal(button.dataset.productId);
          return;
        }
        if (button.dataset.productUrl) {
          window.location.href = button.dataset.productUrl;
        }
      });
    });
  };

  const initialize = (root) => {
    initializeSlider(root);
    initializeAtc(root);
  };

  document.querySelectorAll(rootSelector).forEach(initialize);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(rootSelector).forEach(initialize);
  });
})();
